(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wavelift-size-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wavelift-size-guide')) {
  customElements.define('wavelift-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.dialog = this.querySelector('dialog');
      this.applyButton = this.querySelector('[data-wl-size-apply]');
      this.applyButton.addEventListener('click', () => {
        if (!this.recommendedSize) return;
        document.dispatchEvent(new CustomEvent('obrelle:size-selected', {detail:{size:this.recommendedSize}}));
        const bundle = document.querySelector('wl-bundle');
        if (bundle) { bundle.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'}); bundle.querySelector('[data-wlb-atc]')?.focus({preventScroll:true}); }
      });
      this.form.addEventListener('submit', (event) => event.preventDefault());
      this.form.addEventListener('change', () => this.calculate());
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.closeTable(); });
      this.dialog.addEventListener('close', () => this.onClosed());
      this.querySelectorAll('[data-wl-size-open]').forEach((el) => el.addEventListener('click', () => this.openTable(el)));
      this.querySelector('[data-wl-size-close]').addEventListener('click', () => this.closeTable());
      this.querySelector('[data-wl-size-calc]').addEventListener('click', () => {
        this.opener = null;
        this.closeTable();
        this.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
      if (!window.__wlSizeLinksBound) {
        window.__wlSizeLinksBound = true;
        document.addEventListener('click', (event) => {
          const link = event.target.closest('a[href="#wl-size-table"]');
          if (!link) return;
          event.preventDefault();
          const guide = document.querySelector('wavelift-size-guide');
          if (guide) guide.openTable(link);
        });
      }
    }
    openTable(opener) {
      if (this.dialog.open) return;
      this.opener = opener || null;
      document.documentElement.setAttribute('scroll-lock', '');
      this.dialog.showModal();
    }
    closeTable() {
      document.documentElement.removeAttribute('scroll-lock');
      if (this.dialog.open) this.dialog.close();
    }
    onClosed() {
      document.documentElement.removeAttribute('scroll-lock');
      if (this.opener && this.opener.isConnected && typeof this.opener.focus === 'function') this.opener.focus({ preventScroll: true });
      this.opener = null;
    }
    clear() {
      this.recommendedSize = null;
      this.applyButton.hidden = true;
      this.querySelectorAll('.is-match,.is-active').forEach((el) => el.classList.remove('is-match', 'is-active'));
      this.querySelector('.wl-size__match').hidden = true;
      this.querySelector('.wl-size__missing').hidden = true;
      this.querySelector('.wl-size__value').textContent = '';
    }
    calculate() {
      this.clear();
      const band = this.form.elements.band.value;
      const cup = this.form.elements.cup.value;
      if (!band || !cup) return;
      const cell = Array.from(this.querySelectorAll('td[data-size]')).find((el) => el.dataset.band === band && el.dataset.cup === cup);
      if (!cell || cell.dataset.size === '-') {
        this.querySelector('.wl-size__missing').hidden = false;
        return;
      }
      cell.classList.add('is-match');
      this.querySelectorAll('[data-band-heading]').forEach((el) => el.classList.toggle('is-active', el.dataset.bandHeading === band));
      this.querySelectorAll('[data-cup-heading]').forEach((el) => el.classList.toggle('is-active', el.dataset.cupHeading === cup));
      this.querySelector('.wl-size__value').textContent = cell.dataset.size;
      this.querySelector('.wl-size__match').hidden = false;
      this.recommendedSize = cell.dataset.size;
      this.applyButton.textContent = this.applyButton.dataset.template.replace('[size]', this.recommendedSize);
      this.applyButton.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
